var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle, _circle2, _path29, _path30, _path31, _path32, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "art",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0bf6c;}.cls-2{fill:#d6af56;}.cls-3{fill:#ffdc8d;}.cls-4{fill:#5df9e6;}.cls-5{fill:#041256;}.cls-6{fill:#fff;}.cls-7{fill:#d37c59;}.cls-8{fill:#ea9e83;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,48c-6-3.08-14.5-5-24-5S14,45,8,48v8H56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.05,56A10,10,0,0,0,25,56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.48,43.56A6.42,6.42,0,0,1,22,45.48a2.64,2.64,0,0,0-1,1.92C21,49.92,25.9,52,32,52s11-2,11-4.56a2.64,2.64,0,0,0-1-1.92,6.42,6.42,0,0,1-1.49-1.92,67.48,67.48,0,0,0-17,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,43C22.5,43,14,45,8,48v3.16c5.95-3.07,14.5-5,24-5s18,1.93,24,5V48C50.05,45,41.5,43,32,43Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.62,43.07v2c.79,0,1.58,0,2.38,0,9.5,0,18,1.93,24,5V48c-6-3.08-14.5-5-24-5C31.2,43,30.41,43,29.62,43.07Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.76,40.43V36.52H25.24v3.91A4.84,4.84,0,0,1,23.51,44a2.23,2.23,0,0,0-.87,1.63c0,2.13,4.19,3.86,9.36,3.86s9.36-1.73,9.36-3.86A2.23,2.23,0,0,0,40.49,44,4.84,4.84,0,0,1,38.76,40.43Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M57,57H7V47.42l.54-.28C13.83,43.89,22.75,42,32,42s18.17,1.87,24.46,5.12l.54.28ZM9,55H55V48.64C49,45.7,40.68,44,32,44S15,45.7,9,48.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M41.68,26.45a9.68,9.68,0,1,0-19.06,2.37,22.65,22.65,0,0,1,.78,5.54v.46A5.58,5.58,0,0,0,25.23,39l3.42,3.09A3.5,3.5,0,0,0,31,43h2a3.5,3.5,0,0,0,2.35-.9L38.77,39a5.53,5.53,0,0,0,1.83-4.12v-.55a21.17,21.17,0,0,1,.75-5.43A9.7,9.7,0,0,0,41.68,26.45Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33,43.52H31a4,4,0,0,1-2.69-1l-3.42-3.08a6.14,6.14,0,0,1-2-4.59v-.45a22,22,0,0,0-.76-5.43,10.17,10.17,0,1,1,20-2.49,10,10,0,0,1-.35,2.61,20.79,20.79,0,0,0-.73,5.3v.55a6.11,6.11,0,0,1-2,4.5l-3.42,3.08A4,4,0,0,1,33,43.52ZM32,17.27h-.37A9.18,9.18,0,0,0,23.1,28.7a22.58,22.58,0,0,1,.8,5.67v.45a5.1,5.1,0,0,0,1.66,3.84L29,41.75a3,3,0,0,0,2,.77h2a3,3,0,0,0,2-.77l3.42-3.09a5,5,0,0,0,1.66-3.75v-.55a21.51,21.51,0,0,1,.77-5.56,9.36,9.36,0,0,0,.31-2.35A9.18,9.18,0,0,0,32,17.27Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.92,30.84a.66.66,0,0,1-.74.61.67.67,0,0,1-.61-.73.68.68,0,0,1,.74-.61A.67.67,0,0,1,28.92,30.84Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.08,30.84a.66.66,0,0,0,.74.61.67.67,0,0,0,.61-.73.68.68,0,0,0-.74-.61A.67.67,0,0,0,35.08,30.84Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.63,15.14l-3.39-2a8.45,8.45,0,0,0-8.48,0l-3.39,2a8.5,8.5,0,0,0-4.24,7.35V34.25a2.23,2.23,0,0,0,1.12,1.93l6.69,3.87V34.79a1.47,1.47,0,0,0-.75-1.29l-3-1.74V24.88L32,29.39l7.81-4.51v6.88l-3,1.74a1.47,1.47,0,0,0-.75,1.29v5.26l6.69-3.87a2.23,2.23,0,0,0,1.12-1.93V22.49A8.5,8.5,0,0,0,39.63,15.14Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.87,22.66v-.17a8.5,8.5,0,0,0-4.24-7.35l-3.39-2A8.46,8.46,0,0,0,32,12.05v9.31l-2,2,2,2.25v3.82l7.81-4.51v.76Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.63,15.14l-3.39-2a8.49,8.49,0,0,0-6.62-.79,8.5,8.5,0,0,1,5.15,1.08l3.39,2a8.45,8.45,0,0,1,4.24,7.34V34.54a2.21,2.21,0,0,1-1.11,1.93l-5.23,3v.56l6.69-3.87a2.23,2.23,0,0,0,1.12-1.93V22.49A8.5,8.5,0,0,0,39.63,15.14Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.19,33.5l-3-1.74V26l-1.46-.84v6.88l3,1.73a1.5,1.5,0,0,1,.75,1.29V39.2l1.46.85V34.79A1.47,1.47,0,0,0,27.19,33.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "38.34 25.18 31.52 29.11 32 29.39 38.34 25.73 38.34 25.18"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.17,37.06V36a1.47,1.47,0,0,1,.75-1.29l3-1.74V24.34l-2.11,1.22v6.2l-3,1.74a1.47,1.47,0,0,0-.75,1.29v5.26l2.11-1.22Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.24,35.5V22.67a6.61,6.61,0,0,1,3.32-5.74l4.31-2.49a8.45,8.45,0,0,1,8.48,0l1.63.94-.35-.24-3.39-2a8.45,8.45,0,0,0-8.48,0l-3.39,2a8.5,8.5,0,0,0-4.24,7.35V34.25a2.23,2.23,0,0,0,1.12,1.93l1.94,1.12A2.24,2.24,0,0,1,22.24,35.5Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.19,33.5,26.3,33v0l1.06.62A.55.55,0,0,0,27.19,33.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.06,41.78v-7a2.5,2.5,0,0,1,1.25-2.16l2.5-1.45V26.62L32,30.55l-6.81-3.93v4.56l2.5,1.45a2.5,2.5,0,0,1,1.25,2.16v7l-8.19-4.73a3.25,3.25,0,0,1-1.62-2.8V22.49a9.51,9.51,0,0,1,4.74-8.21l3.39-2a9.5,9.5,0,0,1,9.48,0l3.39,2a9.51,9.51,0,0,1,4.74,8.21V34.25a3.25,3.25,0,0,1-1.62,2.8Zm5.75-18.63v9.19l-3.5,2a.48.48,0,0,0-.25.43v3.52l5.19-3a1.24,1.24,0,0,0,.62-1.07V22.49A7.51,7.51,0,0,0,39.13,16l-3.39-2a7.51,7.51,0,0,0-7.48,0l-3.39,2a7.51,7.51,0,0,0-3.74,6.48V34.25a1.24,1.24,0,0,0,.62,1.07l5.19,3V34.79a.48.48,0,0,0-.25-.43l-3.5-2V23.15L32,28.24Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32,30.55,22.05,24.8a1,1,0,1,1,1-1.73l9,5.17,9-5.17a1,1,0,1,1,1,1.73Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27.59,11v4.37a3.13,3.13,0,0,0,1.58,2.72l1.26.73a3.14,3.14,0,0,0,3.14,0l1.26-.73a3.13,3.13,0,0,0,1.58-2.72V11A.84.84,0,0,0,36,10.3L32,8l-4,2.3A.84.84,0,0,0,27.59,11Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36,10.3,32,8l-1,.59,3.39,2a.84.84,0,0,1,.41.72v4.36a3.15,3.15,0,0,1-1.57,2.73L32,19.08a1.79,1.79,0,0,1-.32.13,3.05,3.05,0,0,0,1.94-.37l1.26-.73a3.13,3.13,0,0,0,1.58-2.72V11A.84.84,0,0,0,36,10.3Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M29.53,16.85V12.48a.84.84,0,0,1,.42-.72l4-2.3,2.45,1.41a.89.89,0,0,0-.4-.57L32,8l-4,2.3a.84.84,0,0,0-.42.72v4.37a3.13,3.13,0,0,0,1.58,2.72l1,.57A3.15,3.15,0,0,1,29.53,16.85Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32,20.26a4.11,4.11,0,0,1-2.07-.55L28.67,19a4.16,4.16,0,0,1-2.08-3.59V11a1.84,1.84,0,0,1,.92-1.58L32,6.85l4.49,2.59A1.84,1.84,0,0,1,37.41,11v4.37A4.16,4.16,0,0,1,35.33,19l-1.26.73A4.11,4.11,0,0,1,32,20.26Zm-3.41-9.14v4.27a2.17,2.17,0,0,0,1.08,1.86l1.26.72a2.1,2.1,0,0,0,2.14,0l1.26-.72a2.17,2.17,0,0,0,1.08-1.86V11.12L32,9.15Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32,24.34l-1-4.59a1,1,0,1,1,2-.44,1.09,1.09,0,0,1,0,.44Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32,13.18l-4.1-2.06a.23.23,0,0,1-.11-.33.24.24,0,0,1,.33-.11l3.88,2,3.88-2a.24.24,0,0,1,.33.11.23.23,0,0,1-.11.33Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32,15.19l-4.1-2.06a.24.24,0,0,1-.11-.34.25.25,0,0,1,.33-.11l3.88,2,3.88-2a.25.25,0,0,1,.33.11.24.24,0,0,1-.11.34Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32,17.2l-4.1-2.07a.23.23,0,0,1-.11-.33.25.25,0,0,1,.33-.11l3.88,2,3.88-2a.25.25,0,0,1,.33.11.23.23,0,0,1-.11.33Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 15.5,
    cy: 51.83,
    r: 1.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 48.5,
    cy: 51.83,
    r: 1.25
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M13.37,48.19l6.07-1.35V42a44.5,44.5,0,0,0-6.07,1.51Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M15.31,44.82c1.3-.42,2.68-.8,4.13-1.12V42a44.5,44.5,0,0,0-6.07,1.51v4.69l1.94-.43Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.37,49.43V42.77l.69-.22A45.31,45.31,0,0,1,19.26,41l1.18-.21v6.86Zm2-5.2v2.71l4.07-.9V43.2C17,43.49,15.67,43.83,14.37,44.23Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.63,48.19l-6.07-1.35V42a44.5,44.5,0,0,1,6.07,1.51Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.69,44.82c-1.3-.42-2.68-.8-4.13-1.12V42a44.5,44.5,0,0,1,6.07,1.51v4.69l-1.94-.43Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.63,49.43l-8.07-1.78V40.79l1.18.21a45.31,45.31,0,0,1,6.2,1.55l.69.22ZM45.56,46l4.07.9V44.23c-1.3-.4-2.66-.74-4.07-1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.0297df4b2d39cd09d68f8bb7d4e1a5a4.svg";
export { ForwardRef as ReactComponent };